/** Leads: VLM_URL (DEFAULT_VLM_URL or REACT_APP_VLM_URL). Main API: API_ENDPOINT_URL. */

// Default VLM URL configuration based on deployment region
const VLM_URL_SG = 'https://alibaba-vlm-tool-sg.voiceracx.ai';
const VLM_URL_US = 'https://alibaba-vlm-tool-us.voiceracx.ai';

// Singapore / Indonesia Region (default)
const DEFAULT_VLM_URL = VLM_URL_SG;

/**
 * VLM base URL: REACT_APP_VLM_URL (build) overrides; otherwise DEFAULT_VLM_URL below.
 * Set DEFAULT_VLM_URL to VLM_URL_SG or VLM_URL_US — that choice is always used.
 */
const resolveVlmUrl = () => {
	if (process.env.REACT_APP_VLM_URL) {
		return process.env.REACT_APP_VLM_URL.replace(/\/$/, '');
	}
	return DEFAULT_VLM_URL;
};

export const getVlmUrl = resolveVlmUrl;

const ACTIVE_VLM_URL = resolveVlmUrl();

console.log(
	'[GenDialer VLM]',
	'SG:', VLM_URL_SG,
	ACTIVE_VLM_URL === VLM_URL_SG ? '← active' : '',
	'| US:', VLM_URL_US,
	ACTIVE_VLM_URL === VLM_URL_US ? '← active' : '',
	'| resolved:', ACTIVE_VLM_URL
);

const dev = {  
	
	//  API_ENDPOINT_URL:  'https://gendialer.voiceracx.ai/vdl/',
	// API_ENDPOINT_URL:  'https://usalibaba.gendialer.voiceracx.ai/vdl/',
	//  API_ENDPOINT_URL:  'https://gendialerqa.voiceracx.ai/vdl/',
	   API_ENDPOINT_URL: 'http://localhost:1010/vdl/',

	   AI_API_URL: 'https://vlmmini.voicera-analytics.com/',
	   VLM_UI_URL: 'https://vlmui.voiceracx.ai',
	   VLM_URL: ACTIVE_VLM_URL,
	
}

const prod = {
	  API_ENDPOINT_URL:  'https://alibaba.gendialer.voiceracx.ai/vdl/',
	// API_ENDPOINT_URL:  'https://usalibaba.gendialer.voiceracx.ai/vdl/',
	//  API_ENDPOINT_URL:  'https://gendialerqa.voiceracx.ai/vdl/',
    //   API_ENDPOINT_URL: 'http://localhost:1010/vdl/',

	   AI_API_URL: 'https://vlmmini.voicera-analytics.com/',
	   VLM_UI_URL: 'https://vlmui.voiceracx.ai',
	   VLM_URL: ACTIVE_VLM_URL,
	
	
};


const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		default:
			break;
	}
}

export const env = getEnv()
